<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.8531 16.5219L17.8319 16.5555L17.7738 16.6336L17.7071 16.7072L12.7071 21.7072C12.1045 22.3097 11.0928 21.9277 11.006 21.1137L11 21.0001L10.9999 14.079L7.62467 16.7809C7.19341 17.1259 6.56412 17.056 6.21911 16.6247C5.90064 16.2267 5.93572 15.6598 6.2822 15.3036L6.37528 15.2192L10.3989 12L6.37528 8.78092C5.94402 8.43591 5.8741 7.80662 6.21911 7.37536C6.53758 6.97727 7.09828 6.88707 7.52185 7.14691L7.62467 7.21918L10.9999 9.92005L11 3.00005C11 2.14788 11.9855 1.70262 12.6225 2.21683L12.7071 2.29294L17.7071 7.29294C17.7545 7.34033 17.796 7.39117 17.8319 7.44462L17.8596 7.48853L17.9043 7.57223L17.9541 7.69963C18.0586 8.04201 17.9797 8.41994 17.7274 8.68648L17.6247 8.78092L13.5999 12L17.6247 15.2192C17.8906 15.4319 18.0171 15.7498 17.9981 16.0618C17.9917 16.1595 17.9727 16.2518 17.9404 16.3409L17.9043 16.4278L17.8531 16.5219ZM13 14.0801V18.5841L15.502 16.0821L13 14.0801ZM13 9.91905V5.41505L15.502 7.91705L13 9.91905Z"
    fill="currentColor"
  />
</svg>
